var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h5", [_vm._v(_vm._s(_vm.labels.burgStaat.objectName))]),
      _vm._v(" "),
      _c("dl", { staticClass: "row" }, [
        _c("dt", { staticClass: "col-sm-3" }, [
          _vm._v(_vm._s(_vm.labels.burgStaat.burgstaat))
        ]),
        _vm._v(" "),
        _c("dd", { staticClass: "col-sm-9" }, [
          _vm._v(_vm._s(_vm.gezin.burgStaat.burgstaat))
        ]),
        _vm._v(" "),
        _c("dt", { staticClass: "col-sm-3" }, [
          _vm._v(_vm._s(_vm.labels.burgStaat.burgstaatDatum))
        ]),
        _vm._v(" "),
        _c("dd", { staticClass: "col-sm-9" }, [
          _vm._v(
            "\n            " +
              _vm._s(
                _vm.gezin.burgStaat.burgstaatDatum ||
                  "(niet gekend of niet van toepassing)"
              ) +
              "\n        "
          )
        ]),
        _vm._v(" "),
        _c("dt", { staticClass: "col-sm-3" }, [
          _vm._v(_vm._s(_vm.labels.burgStaat.huwelijksdatum))
        ]),
        _vm._v(" "),
        _c("dd", { staticClass: "col-sm-9" }, [
          _vm._v(
            "\n            " +
              _vm._s(
                _vm.gezin.burgStaat.huwelijksdatum ||
                  "(niet gekend of niet van toepassing)"
              ) +
              "\n        "
          )
        ])
      ]),
      _vm._v(" "),
      _vm.gezin.partner.voornaam != null
        ? [
            _c("h5", [_vm._v(_vm._s(_vm.labels.partner.objectName))]),
            _vm._v(" "),
            _c(
              "dl",
              { staticClass: "row" },
              [
                _c("dt", { staticClass: "col-sm-3" }, [
                  _vm._v(_vm._s(_vm.labels.partner.naam))
                ]),
                _vm._v(" "),
                _c("dd", { staticClass: "col-sm-9" }, [
                  _vm._v(_vm._s(_vm.gezin.partner.naam))
                ]),
                _vm._v(" "),
                _c("dt", { staticClass: "col-sm-3" }, [
                  _vm._v(_vm._s(_vm.labels.partner.voornaam))
                ]),
                _vm._v(" "),
                _c("dd", { staticClass: "col-sm-9" }, [
                  _vm._v(_vm._s(_vm.gezin.partner.voornaam))
                ]),
                _vm._v(" "),
                !_vm.hiddenFieldsMap.partner.nationaliteit
                  ? [
                      _c("dt", { staticClass: "col-sm-3" }, [
                        _vm._v(_vm._s(_vm.labels.partner.nationaliteit))
                      ]),
                      _vm._v(" "),
                      _c("dd", { staticClass: "col-sm-9" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.gezin.partner.nationaliteit.nationaliteit
                            ) +
                            "\n                "
                        )
                      ])
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _c("dt", { staticClass: "col-sm-3" }, [
                  _vm._v(_vm._s(_vm.labels.partner.geboortedatum))
                ]),
                _vm._v(" "),
                _c("dd", { staticClass: "col-sm-9" }, [
                  _vm._v(_vm._s(_vm.gezin.partner.geboortedatum))
                ]),
                _vm._v(" "),
                !_vm.hiddenFieldsMap.partner.geboorteplaats
                  ? [
                      _c("dt", { staticClass: "col-sm-3" }, [
                        _vm._v(_vm._s(_vm.labels.partner.geboorteplaats))
                      ]),
                      _vm._v(" "),
                      _c("dd", { staticClass: "col-sm-9" }, [
                        _vm._v(_vm._s(_vm.gezin.partner.geboorteplaats))
                      ])
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _c("dt", { staticClass: "col-sm-3" }, [
                  _vm._v(_vm._s(_vm.labels.gezinsleden.mindervalide))
                ]),
                _vm._v(" "),
                _c("dd", { staticClass: "col-sm-9" }, [
                  _vm._v(_vm._s(_vm.gezin.partner.mindervalide ? "Ja" : "Nee"))
                ]),
                _vm._v(" "),
                _c("dt", { staticClass: "col-sm-3" }, [
                  _vm._v(_vm._s(_vm.labels.gezinsleden.tenLaste))
                ]),
                _vm._v(" "),
                _c("dd", { staticClass: "col-sm-9" }, [
                  _vm._v(_vm._s(_vm.gezin.partner.tenLaste ? "Ja" : "Nee"))
                ]),
                _vm._v(" "),
                _c("dt", { staticClass: "col-sm-3" }, [
                  _vm._v(_vm._s(_vm.labels.partner.beroep))
                ]),
                _vm._v(" "),
                _c("dd", { staticClass: "col-sm-9" }, [
                  _vm._v(_vm._s(_vm.gezin.partner.beroep))
                ]),
                _vm._v(" "),
                !_vm.hiddenFieldsMap.partner.werkgever
                  ? [
                      _c("dt", { staticClass: "col-sm-3" }, [
                        _vm._v(_vm._s(_vm.labels.partner.werkgever))
                      ]),
                      _vm._v(" "),
                      _c("dd", { staticClass: "col-sm-9" }, [
                        _vm._v(_vm._s(_vm.gezin.partner.werkgever))
                      ])
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.gezin.partner.partnOverlijdensdatum != null
                  ? [
                      _c("dt", { staticClass: "col-sm-3" }, [
                        _vm._v(_vm._s(_vm.labels.partner.overlijdensdatum))
                      ]),
                      _vm._v(" "),
                      _c("dd", { staticClass: "col-sm-9" }, [
                        _vm._v(_vm._s(_vm.gezin.partner.partnOverlijdensdatum))
                      ])
                    ]
                  : _vm._e()
              ],
              2
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.gezin.gezinsleden.length == 1
        ? _c("h5", [
            _vm._v(
              "\n        " +
                _vm._s(_vm.labels.gezinsleden.objectName.singular) +
                "\n    "
            )
          ])
        : _c("h5", [_vm._v(_vm._s(_vm.labels.gezinsleden.objectName.plural))]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-responsive d-flex justify-content-center" },
        [
          _vm.gezin.gezinsleden.length != 0
            ? _c("table", { staticClass: "table table-striped card-title" }, [
                _c("thead", [
                  _c("tr", [
                    _c("th", { attrs: { scope: "col" } }, [
                      _vm._v(_vm._s(_vm.labels.gezinsleden.verwantschap))
                    ]),
                    _vm._v(" "),
                    _c("th", { attrs: { scope: "col" } }, [
                      _vm._v(_vm._s(_vm.labels.gezinsleden.naam))
                    ]),
                    _vm._v(" "),
                    _c("th", { attrs: { scope: "col" } }, [
                      _vm._v(_vm._s(_vm.labels.gezinsleden.voornaam))
                    ]),
                    _vm._v(" "),
                    _c("th", { attrs: { scope: "col" } }, [
                      _vm._v(_vm._s(_vm.labels.gezinsleden.geboortedatum))
                    ]),
                    _vm._v(" "),
                    _c("th", { attrs: { scope: "col" } }, [
                      _vm._v(_vm._s(_vm.labels.gezinsleden.tenLaste))
                    ]),
                    _vm._v(" "),
                    _c("th", { attrs: { scope: "col" } }, [
                      _vm._v(_vm._s(_vm.labels.gezinsleden.nietMeerTenLaste))
                    ]),
                    _vm._v(" "),
                    _c("th", { attrs: { scope: "col" } }, [
                      _vm._v(_vm._s(_vm.labels.gezinsleden.mindervalide))
                    ]),
                    _vm._v(" "),
                    _c("th", { attrs: { scope: "col" } }, [
                      _vm._v(_vm._s(_vm.labels.gezinsleden.zorgbehoevend))
                    ]),
                    _vm._v(" "),
                    _c("th", { attrs: { scope: "col" } }, [
                      _vm._v(_vm._s(_vm.labels.gezinsleden.overlijdensdatum))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.gezin.gezinsleden, function(gezinslid, index) {
                    return _c(
                      "tr",
                      { key: "tr-gezinslid-" + parseInt(index) },
                      [
                        gezinslid.verwantschap
                          ? _c("td", [_vm._v(_vm._s(gezinslid.verwantschap))])
                          : _vm._e(),
                        _vm._v(" "),
                        gezinslid.verwantschap == ""
                          ? _c("td", [_vm._v("?")])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(gezinslid.naam))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(gezinslid.voornaam))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(gezinslid.geboortedatum))]),
                        _vm._v(" "),
                        gezinslid.tenLaste
                          ? _c("td", [_vm._v("Ja")])
                          : _vm._e(),
                        _vm._v(" "),
                        !gezinslid.tenLaste
                          ? _c("td", [_vm._v("Nee")])
                          : _vm._e(),
                        _vm._v(" "),
                        gezinslid.nietMeerTenLaste
                          ? _c("td", [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(gezinslid.nietMeerTenLaste) +
                                  "\n                "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        gezinslid.nietMeerTenLaste == null
                          ? _c("td", [_vm._v("/")])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(gezinslid.mindervalide ? "Ja" : "Nee"))
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(gezinslid.zorgbehoevend ? "Ja" : "Nee"))
                        ]),
                        _vm._v(" "),
                        gezinslid.overlijdensdatum != null
                          ? _c("td", [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(gezinslid.overlijdensdatum) +
                                  "\n                "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        gezinslid.overlijdensdatum == null
                          ? _c("td", [_vm._v("/")])
                          : _vm._e()
                      ]
                    )
                  }),
                  0
                )
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm.gezin.gezinsleden.length == 0
        ? _c("p", { staticClass: "text-secondary" }, [
            _vm._v("\n        Geen gezinsleden.\n    ")
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }